import type { NskResponse } from "~/models/Api";
import type { RelatedDealParam } from "~/models/DealForm";
import { postRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";
import { getKeys } from "../../getKeys";

const paths = {
	create: "deals/:deal_id/related_deals"
} as const;

export const create = async (
	deal: RelatedDealParam,
	originalDealId: number
): Promise<NskResponse<{ id: number }>> => {
	const formData = new FormData();

	getKeys(deal).forEach((key) => {
		if (deal[key] === null) return;

		if (key === "staff" || key === "dealSubtype" || key === "companyVendor") {
			formData.append(`deal[${key}][id]`, String(deal[key]?.id));
			return;
		}

		if (key === "showTenant" || key === "estimationByCompany") {
			formData.append(`deal[${key}]`, String(deal[key]));
			return;
		}

		if (key === "dealRepair") {
			const dealRepair = deal[key];
			if (dealRepair === null) return;

			getKeys(dealRepair).forEach((repairKey) => {
				const dealRepairValue = dealRepair[repairKey];
				if (dealRepairValue === null) return;

				formData.append(`deal[${key}][${repairKey}]`, dealRepairValue);
			});
			return;
		}

		const dealValue = deal[key];
		if (dealValue === null) return;

		formData.append(`deal[${key}]`, String(dealValue));
	});

	const result = postRequest<{ id: number }, null>(
		generatePath(paths.create, { deal_id: originalDealId }),
		formData
	);
	return result;
};
